import React, { useEffect, useRef } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { GenericLoading } from '../../components/Placeholders';
import { getCachedUserToken } from '../../utilities/caching';
import { useUsEnv } from '../../utilities/sharedHooks/useUsEnv';
import { OAUTH_SESSION_KEYS } from './constants';
import { switchEnvFromAppName } from '../../utilities/oauthEnvSwitch';
import OauthLayout from './partials/Layout';

const OauthRedirectionHandlerComponent = () => {
  const formRef = useRef();
  const { isUsEnv } = useUsEnv();
  const { oauthInteractionUid } = useParams();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const appName = searchParams.get('app');
  const switchUrl = searchParams.get('switchEnvPath');

  const baseUrl = isUsEnv
    ? process.env.REACT_APP_US_API_BASE_URL
    : process.env.REACT_APP_API_BASE_URL;

  const token = getCachedUserToken();

  useEffect(() => {
    if (appName) {
      const { shouldSubmit } = switchEnvFromAppName({
        appName,
        isUsEnv,
        oauthInteractionUid,
        switchUrl: switchUrl || sessionStorage.getItem(OAUTH_SESSION_KEYS.SWITCH_ENV_PATH),
      });
      if (formRef && shouldSubmit) {
        formRef.current.submit();
      }
    }
  }, [appName, isUsEnv, oauthInteractionUid, switchUrl]);

  return (
    <OauthLayout>
      <div
        className="d-flex justify-content-center align-content-center"
        style={{ minHeight: '30vh' }}>
        <GenericLoading isFullScreen={false} customSize="4rem" />
      </div>
      <form
        ref={formRef}
        action={`${baseUrl}oauth2/interaction/${oauthInteractionUid}`}
        method="POST">
        <input type="hidden" name="access_token" value={token} />
      </form>
    </OauthLayout>
  );
};

export default OauthRedirectionHandlerComponent;
